import { createAction } from 'redux-actions';

import {GET_STEM_KITS, GET_STEM_KIT, ADD_STEM_KIT_ORDER} from './constants';
import {getStemKits, getStemKit, addStemKitOrderApi} from './api';

export const getStemKitsAction = createAction(GET_STEM_KITS, async () => getStemKits());
export const getStemKitAction = createAction(GET_STEM_KIT, async (id) => getStemKit(id));
export const addStemKitOrderAction = createAction(ADD_STEM_KIT_ORDER, async (data) => addStemKitOrderApi(data));